import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, StakeholderWithJobInfo } from "@/types";

export function useGetStakeholders() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["stakeholders", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/stakeholders`;
      const res = await guacHttpClient.get<
        StakeholderWithJobInfo[],
        HttpResponse<StakeholderWithJobInfo[]>
      >(path);
      return res.data;
    },
  });
}
